import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IBarrierActionData } from 'apis/ActionTracker/getBarrierActionTracker';

const initialState: IBarrierActionData = {
    action: "",
    tag: "",
    progress_percent: null,
    audit_id: "",
    asset: "",
    assigned_to: "",
    audit_entry_form_metadata: "",
    comments: "",
    raised_by: "",
    completed_at: "",
    created_at: "",
    created_by: "",
    deleted_at: "",
    due_date: "",
    event: "",
    facility_id: "",
    id: "",
    location: "",
    priority: "",
    priority_value: "",
    project_id: "",
    sce: "",
    status: "",
    status_value: "",
    updated_at: "",
    updated_by: "",
    barriers: [],
    barrier_type: "",
    barrier_status: "",
    metric: "",
    metric_description: "",
    attachments: []
}

const modalStateSlice = createSlice({
    name: 'ActionTrackerEditData',
    initialState,
    reducers: {
        setActionTrackerEditDataState: (state, action: PayloadAction<Partial<IBarrierActionData>>) => {
            Object.assign(state, action.payload);
        },
    },
});

export const { setActionTrackerEditDataState } = modalStateSlice.actions;
export default modalStateSlice.reducer;
